export const Mark = Object.freeze({
	Positive: 'positive',
	Negative: 'negative',
	None: 'none',
});
